import { Alert, Button, Modal, Space } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { CustomTextField } from "~/components";
import {
  ENVS,
  buildTenantPortalInviteUrl,
  tenantInviteReturnPathForProperty,
  tenantInviteReturnPathForUnit,
} from "~/utils";

type InviteTenantButtonProps =
  | {
      variant: "property";
      propertyId: string;
      /** antd Button `type` — default `default` */
      buttonType?: "default" | "primary" | "link" | "text" | "dashed";
      ghost?: boolean;
    }
  | {
      variant: "unit";
      unitId: string;
      buttonType?: "default" | "primary" | "link" | "text" | "dashed";
      ghost?: boolean;
    };

export const InviteTenantButton = (props: InviteTenantButtonProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);

  const buttonType = props.buttonType ?? "default";
  const ghost = props.ghost ?? false;

  const inviteUrl = React.useMemo(() => {
    if (!ENVS.tenant_portal_url) {
      return "";
    }
    const returnPath =
      props.variant === "property"
        ? tenantInviteReturnPathForProperty(props.propertyId)
        : tenantInviteReturnPathForUnit(props.unitId);
    return buildTenantPortalInviteUrl(returnPath);
  }, [props]);

  const description =
    props.variant === "property"
      ? t("Invite_Tenant_Property_Description")
      : t("Invite_Tenant_Unit_Description");

  return (
    <>
      <Button
        type={buttonType}
        ghost={ghost}
        onClick={() => setOpen(true)}
      >
        {t("Invite_Tenant")}
      </Button>

      <Modal
        title={t("Invite_Tenant")}
        open={open}
        onCancel={() => setOpen(false)}
        footer={[
          <Button key="close" type="primary" onClick={() => setOpen(false)}>
            {t("Cancel")}
          </Button>,
        ]}
        destroyOnClose
      >
        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
          {!ENVS.tenant_portal_url ? (
            <Alert type="warning" message={t("Tenant_portal_not_configured")} showIcon />
          ) : (
            <>
              <p style={{ margin: 0 }}>{description}</p>
              <CustomTextField value={inviteUrl} copyable />
            </>
          )}
        </Space>
      </Modal>
    </>
  );
};
